


















import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component<CEmoticonInput>({})
export default class CEmoticonInput extends Vue {
  icons: string[] = [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '😅',
    '😂',
    '🤣',
    '😭',
    '😗',
    '😙',
    '😚',
    '😘',
    '🥰',
    '😍',
    '🤩',
    '🥳',
    '🤗',
    '🙃',
    '🙂',
    '️😊',
    '😏',
    '😌',
    '😉',
    '🤭',
    '😶',
    '😶',
    '🤔',
    '🤪',
    '😜',
    '😝',
    '😛',
    '😋',
    '😔',
    '😑',
    '😐',
    '☹️',
    '🤬',
    '😡',
    '😠',
    '😤',
    '😒',
    '🙄',
    '🧐',
    '🤨',
    '😰',
    '🤫',
    '🤐',
    '😬',
    '😳',
    '🥺',
    '😟',
    '😕',
    '🙁',
    '😢',
    '🤯',
    '😱',
    '😲',
    '😯',
    '😮',
    '😦',
    '😧',
    '😨',
    '🥱',
    '🤤',
    '😫',
    '😩',
    '😣',
    '😖',
    '😞',
    '😓',
    '😥',
  ];
}
